module.exports = function() { return __webpack_public_path__ + "when-traveling-xs@2x.IwmcX3LEAKoep-h8VbPI.png";};